module.exports = __webpack_public_path__ + "01_glasses_black.39f1a830.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/01_glasses_black.png
// module id = 258s
// module chunks = 0